var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "settings-engineers-security-group" } },
    [
      _c(
        "div",
        { staticStyle: { display: "inline", "vertical-align": "middle" } },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("total")) +
                ": " +
                _vm._s(_vm.filteredUsers.length) +
                " / " +
                _vm._s(_vm.recordCounts)
            ),
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-refresh dark flat icon_refresh",
            on: { click: _vm.refreshData },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.hasSettingsUpdateAcess
        ? _c(
            "div",
            { staticClass: "row controls" },
            [
              _c("HKLButton", {
                attrs: { color: "darkblue", action: "resetFilter" },
                on: { click: _vm.resetFilter },
              }),
              _vm._v(" "),
              _c("HKLButton", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.allowEdit,
                    expression: "!allowEdit",
                  },
                ],
                attrs: { color: "orange", action: "invite" },
                on: {
                  click: function ($event) {
                    return _vm.showInviteUserModal()
                  },
                },
              }),
              _vm._v(" "),
              !_vm.allowEdit
                ? _c("HKLButton", {
                    attrs: { color: "orange", action: "edit" },
                    on: {
                      click: function ($event) {
                        return _vm.enableEdit()
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c("HKLButton", {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    attrs: { color: "darkblue", action: "cancel" },
                    on: {
                      click: function ($event) {
                        return _vm.discardChange()
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c("HKLButton", {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    attrs: { color: "orange", action: "save" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "settings-engineers-users-hkland-data" } }, [
        _c("table", { staticClass: "setting-table" }, [
          _c(
            "thead",
            [
              _vm._l(_vm.defaultHeaders, function (item, keyName) {
                return _c(
                  "th",
                  {
                    key: keyName,
                    class: item.class,
                    on: {
                      click: function ($event) {
                        return _vm.sortingFn(item, keyName)
                      },
                    },
                  },
                  [
                    _vm._v("\n          " + _vm._s(item.name) + "\n          "),
                    _c("HKLSortingIcon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.userSettingSorting.colName === keyName,
                          expression: "userSettingSorting.colName === keyName",
                        },
                      ],
                      attrs: { iconDirection: _vm.sortingDirection },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.filteredRoles, function (role, index) {
                return _c("th", { key: role.id }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        id: "settings-engineers-users-hkland-role-" + index,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.navToRoleDetail(role.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(role.name) + "\n            "
                      ),
                      _c("i", {
                        staticClass: "fa fa-external-link",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                ])
              }),
              _vm._v(" "),
              _c("th", { staticStyle: { "min-width": "65px" } }, [
                _c(
                  "button",
                  {
                    staticClass: "btn icon right",
                    attrs: {
                      id: "settings-engineers-users-hkland-right-arrow",
                      type: "button",
                      disabled:
                        Math.ceil(_vm.roles.length / _vm.headerPageSize) <=
                        _vm.headerPageNum,
                    },
                    on: {
                      click: function ($event) {
                        _vm.headerPageNum += 1
                      },
                    },
                  },
                  [_vm._v("▶")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn icon right",
                    attrs: {
                      id: "settings-engineers-users-hkland-left-arrow",
                      type: "button",
                      disabled: _vm.headerPageNum <= 1,
                    },
                    on: {
                      click: function ($event) {
                        _vm.headerPageNum -= 1
                      },
                    },
                  },
                  [_vm._v("◀")]
                ),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _c(
                "tr",
                [
                  _c(
                    "td",
                    { staticClass: "user-name" },
                    [
                      _c("HKLInput", {
                        staticClass: "setting-users-filter-search",
                        model: {
                          value: _vm.filterValues.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.filterValues, "name", $$v)
                          },
                          expression: "filterValues.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "user-status settings-filter" }, [
                    _c(
                      "div",
                      [
                        _c("HKLSelect", {
                          staticClass: "align-center",
                          attrs: {
                            "settings-filter-row": "",
                            options: _vm.statusFilterOptions,
                            showSearch: false,
                            placeholder: "",
                          },
                          model: {
                            value: _vm.filterValues.enabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterValues, "enabled", $$v)
                            },
                            expression: "filterValues.enabled",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "last-login" }),
                  _vm._v(" "),
                  _vm._l(_vm.filteredRoles, function (role) {
                    return _c("td", { key: role.id })
                  }),
                  _vm._v(" "),
                  _c("td"),
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.sortedUsers, function (user, index) {
                return [
                  _c(
                    "tr",
                    { key: user.id },
                    [
                      _c("td", { staticClass: "user-name" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              id:
                                "settings-engineers-users-hkland-user-" + index,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.navToUserDetail(user.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(user.name) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "user-status" }, [
                        _c("div", [_vm._v(_vm._s(user.status))]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "last-login" }, [
                        _c("div", [_vm._v(_vm._s(user.lastLoginAt))]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.filteredRoles, function (role, roleIndex) {
                        return _c("td", { key: role.id }, [
                          _vm.allowEdit || user.checked[role.id]
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: user.checked[role.id],
                                    expression: "user.checked[role.id]",
                                  },
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                attrs: {
                                  id:
                                    "settings-engineers-users-hkland-role-checkbox" +
                                    roleIndex,
                                  type: "checkbox",
                                  disabled: !_vm.allowEdit || role.disable,
                                },
                                domProps: {
                                  checked: Array.isArray(user.checked[role.id])
                                    ? _vm._i(user.checked[role.id], null) > -1
                                    : user.checked[role.id],
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = user.checked[role.id],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              user.checked,
                                              role.id,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              user.checked,
                                              role.id,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(user.checked, role.id, $$c)
                                      }
                                    },
                                    function ($event) {
                                      return _vm.updateGrantedAccess(
                                        user,
                                        role.id,
                                        user.checked[role.id]
                                      )
                                    },
                                  ],
                                },
                              })
                            : _vm._e(),
                        ])
                      }),
                      _vm._v(" "),
                      _c("td"),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("InviteUserModal", { ref: "inviteUserModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }